// conversations-list-item.component.ts
import { Component, Input } from '@angular/core';
import { User } from '../../../models/identity/user.model';
import { Conversation } from '../../type/conversation.type';

@Component({
    selector: 'app-conversations-list-item',
    templateUrl: './conversations-list-item.component.html',
    styleUrls: ['./conversations-list-item.component.scss'],
})
export class ConversationsListItemComponent {
    @Input() conversation!: Conversation;

    @Input() notifCount: number = 0;
    @Input() lastMessage: string = '';
    @Input() targetUser: User | null = null;
}
